<div class="list">
  <mat-progress-bar class="loading" mode="indeterminate" [class.hidden]="!loading" />
  <table>
    <colgroup>
      @for (column of columns; track column.id) {
        <col [style.width]="column.width" />
      }
    </colgroup>
    <thead>
      <tr>
        @for (column of columns; track column.id) {
          <th
            [class.active]="sortBy === column.id"
            [title]="column.label"
            (click)="onSort(column.id)"
          >
            {{ column.label }}
            @if (sortBy === column.id) {
              <mat-icon class="sort-icon">
                {{ sortDirection === "asc" ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            }
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (row of rows ?? []; track row.oppId) {
        <tr [class.initiated]="!!row.programId">
          <td [title]="row.accountName">{{ row.accountName }}</td>
          <td [title]="row.opportunityName">{{ row.opportunityName }}</td>
          <td [title]="row.opportunityStage ?? ''">{{ row.opportunityStage }}</td>
          <td [title]="row.opportunityBU ?? ''">{{ row.opportunityBU }}</td>
          <td [title]="row.opportunityClass ?? ''">{{ row.opportunityClass }}</td>
          <td [title]="row.opportunitySubClass ?? ''">{{ row.opportunitySubClass }}</td>
          <td [title]="row.opportunityRiskType ?? ''">{{ row.opportunityRiskType }}</td>
          <td>{{ row.opportunityInceptionDate | date: "d MMM yyyy" }}</td>
          <td [title]="row.programName ?? ''">
            @if (row.programId) {
              <span class="initiated-date">
                {{ row.initiatedDate ? (row.initiatedDate | date: "d MMM yyyy") : "Initiated" }}
              </span>
            } @else {
              <button
                appButton
                border
                tiny
                type="button"
                [disabled]="isSaving"
                (click)="initiate.emit(row)"
              >
                {{ isSaving && initiatingOppId === row.oppId ? "Processing..." : "Initiate" }}
              </button>
            }
          </td>
        </tr>
      } @empty {
        @if (!loading) {
          <tr class="empty">
            <td [attr.colspan]="columns.length">{{ emptyMessage }}</td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>

@if (totalCount > 0) {
  <mat-paginator
    showFirstLastButtons
    [length]="totalCount"
    [pageIndex]="page - 1"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPage($event)"
  />
}
